var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"success_notification"}}),_c('AppHeader'),_c('router-view'),_c('AppFooter'),_c('scroll-to-top-button'),(_vm.showToolBar)?_c('BrandCentre'):_vm._e(),_c('ConfirmDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }